/** 天数筛选选项 */
export const DURATIONS = ["不限天数", "1-3天", "4-7天", "7天以上"] as const;

/** 天数筛选值映射（索引 → API 参数） */
export const DURATION_VALUE_MAP: Record<number, number | undefined> = {
  0: undefined,
  1: 1, // 1-3天
  2: 4, // 4-6天
  3: 7, // 7天及以上
};
